/* eslint-disable */
import { useEffect, useRef } from "react";
import { supabase } from "../supabase";

// AUD-05 P1: the heartbeat runs only while the tab is visible, every 4 min (was 60 s, always),
// plus one beat the moment the tab becomes visible again. 4 min, not 5, because every reader of
// user_sessions counts "online" as last_seen_at within 5 min (useMonitorData, useAccessControlData,
// UserManagement): a visible tab always stays inside that window. A tab hidden for more than
// ~5 min now drops out of "Online now" until it is looked at again.
export const HEARTBEAT_MS = 4 * 60 * 1000;

export function useSessionTracking({ user, onLogout }) {
  const sessionIdRef = useRef(null);

  // Session heartbeat
  useEffect(() => {
    const trackSession = async () => {
      const { data } = await supabase.from('user_sessions').insert({
        user_id: user.id, email: user.email, user_agent: navigator.userAgent,
        logged_in_at: new Date().toISOString(), last_seen_at: new Date().toISOString()
      }).select('id').single();
      if (data?.id) sessionIdRef.current = data.id;
    };
    const beat = async () => {
      if (sessionIdRef.current) {
        await supabase.from('user_sessions').update({ last_seen_at: new Date().toISOString() }).eq('id', sessionIdRef.current);
      }
    };
    let interval = null;
    const start = () => { if (!interval) interval = setInterval(beat, HEARTBEAT_MS); };
    const stop = () => { clearInterval(interval); interval = null; };
    const onVisibility = () => {
      if (document.visibilityState !== 'visible') { stop(); return; }
      beat(); start();
    };
    trackSession();                                        // the insert on load, visible or not
    if (document.visibilityState === 'visible') start();
    document.addEventListener('visibilitychange', onVisibility);
    return () => { stop(); document.removeEventListener('visibilitychange', onVisibility); };
  }, [user.id]);

  // Inactivity logout (30 min)
  useEffect(() => {
    const TIMEOUT = 30 * 60 * 1000;
    let timer = setTimeout(onLogout, TIMEOUT);
    const reset = () => { clearTimeout(timer); timer = setTimeout(onLogout, TIMEOUT); };
    ["mousemove", "keydown", "click", "touchstart"].forEach(e => window.addEventListener(e, reset));
    return () => { clearTimeout(timer); ["mousemove", "keydown", "click", "touchstart"].forEach(e => window.removeEventListener(e, reset)); };
  }, [onLogout]);
}
